<template>
    <div class="intro-y box p-5 mt-5">
        <div class="flex justify-end mb-4">
            <a
                :href="`https://kruizy-rossii.com/gorod-pribytiya/${getParentSlug}${form.fields.slug}/`"
                target="_blank"
                class="btn btn-outline-secondary w-30"
                :class="{ 'cursor-wait pointer-events-none opacity-50': loading }"
            >
                Перейти на страницу
            </a>
        </div>

        <form method="post" class="grid grid-cols-12 gap-6" :class="{ 'disabled-form': loading }">
            <div v-if="loading" class="absolute z-100 left-0 top-0 w-full h-full flex items-center justify-center">
                <Preloader />
            </div>

            <div class="relative col-span-6">
                <label for="form-preview-title" class="form-label">
                    Название в превью
                    <sup v-if="v$.form.fields.preview_title.required" class="text-theme-6">*</sup>
                </label>
                <label
                    v-if="v$.form.fields.preview_title.$errors.length"
                    for="form-preview-title"
                    class="form-input-text-error"
                >
                    {{ getOverrideMessage(v$.form.fields.preview_title.$errors[0].$message) }}
                </label>
                <input
                    id="form-preview-title"
                    v-model="form.fields.preview_title"
                    type="text"
                    class="form-control w-full"
                    :class="{ 'form-input-error': v$.form.fields.preview_title.$errors.length }"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="relative col-span-6">
                <label for="form-title" class="form-label">
                    Название на детальной странице
                    <sup v-if="v$.form.fields.title.required" class="text-theme-6">*</sup>
                </label>
                <label v-if="v$.form.fields.title.$errors.length" for="form-title" class="form-input-text-error">
                    {{ getOverrideMessage(v$.form.fields.title.$errors[0].$message) }}
                </label>
                <input
                    id="form-title"
                    v-model="form.fields.title"
                    type="text"
                    class="form-control w-full"
                    :class="{ 'form-input-error': v$.form.fields.title.$errors.length }"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="relative col-span-6">
                <label for="form-link" class="form-label">
                    Ссылка
                    <sup v-if="v$.form.fields.slug.required" class="text-theme-6">*</sup>
                </label>
                <label v-if="v$.form.fields.slug.$errors.length" for="form-link" class="form-input-text-error">
                    {{ getOverrideMessage(v$.form.fields.slug.$errors[0].$message) }}
                </label>
                <input
                    id="form-link"
                    v-model="form.fields.slug"
                    type="text"
                    class="form-control w-full"
                    :class="{ 'form-input-error': v$.form.fields.slug.$errors.length }"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="relative col-span-6" title="Порядковый номер города от 0 до 65535">
                <label for="form-order" class="form-label">
                    Сортировка
                    <sup v-if="v$.form.fields.order.required" class="text-theme-6">*</sup>
                </label>
                <label v-if="v$.form.fields.order.$errors.length" for="form-order" class="form-input-text-error">
                    {{ getOverrideMessage(v$.form.fields.order.$errors[0].$message) }}
                </label>
                <input
                    id="form-order"
                    v-model="form.fields.order"
                    type="text"
                    class="form-control w-full"
                    :class="{ 'form-input-error': v$.form.fields.order.$errors.length }"
                    placeholder="Порядковый номер города от 0 до 65535"
                    autocomplete="off"
                />
            </div>

            <div class="col-span-6">
                <label for="form-parent_id" class="form-label">Родительское направление</label>
                <Multiselect
                    id="form-parent_id"
                    v-model="form.fields.parent_id"
                    track-by="title"
                    label="title"
                    value-prop="id"
                    placeholder="Выберите родителя"
                    :hide-selected="false"
                    :close-on-select="false"
                    :searchable="true"
                    :options="parentOptions"
                />
            </div>

            <div class="col-span-4">
                <label for="form-sale_visible" class="form-label">Текст акции на картинке</label>
                <select id="form-sale_visible" v-model="form.sale_visible" class="form-select">
                    <option :value="true">Виден</option>
                    <option :value="false">Скрыт</option>
                </select>
            </div>

            <div class="col-span-2 flex items-center pt-6 mb-5">
                <input
                    id="form-published"
                    v-model="form.fields.published"
                    class="show-code form-check-switch flex-none mr-0 ml-3"
                    type="checkbox"
                />
                <label for="form-published" class="form-check-label">Опубликовано</label>
            </div>

            <div class="col-span-12">
                <label for="form-subtitle" class="form-label">Подзаголовок</label>
                <input
                    id="form-subtitle"
                    v-model="form.fields.subtitle"
                    type="text"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="col-span-12">
                <label for="form-faq_ids" class="form-label">Вопросы и ответы</label>
                <Multiselect
                    id="form-faq_ids"
                    :key="multiSelectMount"
                    v-model="form.faq_ids"
                    mode="tags"
                    placeholder="Выберите несколько вопросов"
                    track-by="question"
                    label="question"
                    value-prop="id"
                    :hide-selected="false"
                    :close-on-select="false"
                    :searchable="true"
                    :options="faq"
                    no-results-text="Не найдено"
                    no-options-text="Не найдено"
                    :native="false"
                >
                    <template #option="{ option }">
                        {{ option.question }}
                    </template>
                </Multiselect>
            </div>

            <div class="col-span-12">
                <label for="form-description" class="form-label">Описание</label>
                <CustomWyswig id="form-description" v-model="form.fields.description" class="form-control w-full" />
            </div>

            <div class="col-span-12">
                <label for="form-search-title" class="form-label">Заголовок поиска</label>
                <input
                    id="form-search-title"
                    v-model="form.fields.search_title"
                    type="text"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="relative col-span-12">
                <label class="form-label"> Изображение </label>
                <UploadImageNew
                    v-model="form.fields.image"
                    v-model:delete="form.fields.images_delete"
                    recommended-sizes="1170x300px"
                />
            </div>

            <div class="col-span-12">
                <label class="form-label">Превью изображение</label>
                <UploadImageNew
                    v-model="form.fields.image_preview"
                    v-model:delete="form.fields.images_preview_delete"
                    recommended-sizes="350x210px"
                />
            </div>

            <div class="col-span-12">
                <label for="form-attractions-title" class="form-label">Заголовок достопримечательностей</label>
                <input
                    id="form-attractions-title"
                    v-model="form.fields.attractions_title"
                    type="text"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="col-span-12">
                <label class="form-label font-bold">Достопримечательности</label>
                <p v-if="attractionOptions.length === 0">Отсутствуют</p>
                <MultiselectTable
                    v-else
                    v-model="form.attractions"
                    :options="attractionOptions"
                    :header-labels="headerLabels"
                />
            </div>

            <div class="col-span-12">
                <h4 class="font-bold text-xl mb-3">Seo</h4>
                <label for="form-seo-title" class="form-label">Seo заголовок</label>
                <input
                    id="form-seo-title"
                    v-model="form.fields.seo_title"
                    type="text"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="col-span-12">
                <label for="form-seo_text" class="form-label">Seo текст</label>
                <CustomWyswig id="form-seo_text" v-model="form.fields.seo_text" class="form-control w-full" />
            </div>

            <div class="col-span-12" title="SEO тэг для каждого круиза на этой странице">
                <label for="form-hidden_tag" class="form-label">Скрытые тэги</label>

                <Multiselect
                    id="form-hidden_tag"
                    v-model="form.hidden_tag"
                    :options="form.hidden_tag"
                    mode="tags"
                    placeholder="SEO тэги для каждого круиза на этой странице"
                    :hide-selected="false"
                    :close-on-select="false"
                    :native="false"
                    :searchable="true"
                    :create-option="true"
                    no-results-text="Введите новый тэг и Enter чтобы создать"
                    no-options-text="Введите новый тэг и Enter чтобы создать"
                />
            </div>

            <div class="col-span-12">
                <label class="form-label font-bold">Кастомные поля</label>
                <TeamsTable v-if="form.seo" v-model="form.seo" :meta="null" :headers="seoHeaders" class="mb-3" />
                <SearchParamFillInfo />
            </div>

            <div class="col-span-12 flex items-center justify-end mt-5">
                <router-link to="#" class="btn btn-secondary w-24 mr-2 mb-2" @click.prevent="redirectToMainPage">
                    Отмена
                </router-link>
                <button type="submit" class="btn btn-primary mb-2 mr-2" @click.prevent="save(true)">
                    Сохранить и выйти
                </button>
                <button type="submit" class="btn btn-primary mb-2" @click.prevent="save()">Сохранить</button>
            </div>
        </form>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, numeric, minValue, maxValue } from '@vuelidate/validators';
import Preloader from '@/components/preloader/Main';
import UploadImageNew from '@/components/upload-image/UploadImageNew';
import CustomWyswig from '@/components/base/custom-wyswig/Main';
import TeamsTable from '@/components/tables/TeamsTable';
import { cityArrivalMixin } from '@/mixins/form/city-arrivals-mixin';
import { errorResponse } from '@/mixins/form/form-mixin';
import Multiselect from '@vueform/multiselect';
import SearchParamFillInfo from '@/components/banners/SearchParamFillInfo';
import MultiselectTable from '@/components/tables/MultiselectTable';
import { helper as $h } from '@/utils/helper';
import { formPreparation } from '@/utils/object-to-form-data';
import { pageMixin } from '@/mixins/pageMixin';

export default {
    name: 'Edit',
    components: {
        MultiselectTable,
        Preloader,
        UploadImageNew,
        CustomWyswig,
        TeamsTable,
        Multiselect,
        SearchParamFillInfo,
    },
    mixins: [cityArrivalMixin, errorResponse, pageMixin],
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            headerLabels: ['Достопримечательность'],
        };
    },
    validations() {
        return {
            form: {
                fields: {
                    preview_title: { required },
                    title: { required },
                    slug: { required },
                    order: { required, numeric, minValue: minValue(0), maxValue: maxValue(65535) },
                },
            },
        };
    },
    computed: {
        getParentSlug() {
            if (!this.form.fields.parent_id) return '';

            const parent = this.parentOptions.filter((option) => option.id === this.form.fields.parent_id)[0];

            return parent ? `${parent.slug}/` : '';
        },
    },
    async created() {
        this.$store.commit('main/setPageHeader', 'Редактирование города прибытия');
        await this.fetchEditParams();
    },
    methods: {
        async save(redirect = false) {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                this.$notify({ text: 'Заполните все поля правильно', type: 'error' });
                return;
            }

            this.loading = true;

            try {
                const formData = formPreparation(this.form, {
                    nullsAsUndefineds: false,
                    imagesAsObject: true,
                });
                const { data } = await this.axios.post('/city-arrivals/' + this.$route.params.id, formData, {
                    params: { _method: 'patch' },
                });

                this.form.slug = data.data.slug;
                this.$notify(data.message);

                if (redirect) {
                    this.redirectToMainPage();
                    // await this.$router.push({ name: 'city-arrivals' });
                }
            } catch (ex) {
                this.errorResponse(ex);
            } finally {
                this.loading = false;
            }
        },
        async fetchEditParams() {
            this.loading = true;

            try {
                const { data } = await this.axios.get(`/city-arrivals/${this.$route.params.id}/edit`);

                // заполняем данные
                for (const [key, val] of Object.entries(data.data.city_arrival)) {
                    this.form.fields[key] = val;
                }
                this.form.hidden_tag = data.data.city_arrival.hidden_tag; // бэк сказал, что это не филд ¯\_(ツ)_/¯

                const response = { ...data.data };

                this.form.seo = this.form.fields.seo || this.getDefaultSeo();

                this.form.attractions = response.city_arrival.attractions;

                this.form.faq_ids = data.data.city_arrival.faq.map(({ id }) => id);

                this.multiSelectMount += 1;

                this.attractionOptions = response.attractions;
                this.parentOptions = response.arrivals;
            } catch (ex) {
                console.log('cannot fetch popular-direction edit params ' + ex);
                this.$router.push('/error-page');
            } finally {
                this.loading = false;
            }
        },
        getOverrideMessage(message) {
            return $h.getOverrideMessage(message);
        },
        redirectToMainPage() {
            this._pMTransitionToEditPageWithQuery('city-arrivals');
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep {
    .multiselect-dropdown {
        max-height: 400px;
    }
}
</style>
